import { render, staticRenderFns } from "./reward_gift.vue?vue&type=template&id=68b9e7fe"
import script from "./reward_gift.vue?vue&type=script&lang=js"
export * from "./reward_gift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports